import { EcosystemServiceModel } from "@shared/models/ecosystem-service.model";

export const _17_RECREATION:Partial<EcosystemServiceModel> ={
  id:'recreation',
  pos:17,
  image: "/images/ecoservices/recreation.jpg",
  code: ["3.1.1.1", "3.1.1.2","6.1.1.1"],
  unit:'recreation',
  assetType:'socialUses',
  serviceType: 'cultural',
  valuationMethods:[
    {
      id: 'travelcost',
      name:"Travel Cost",
      unit: "visitor",
      element: "Visitors",
      altUnits: null,
      qtyIndices: [
        { id: "quality", name: "Quality Index", included: true },
      ],
      valueIndices: []
    },
    {
      id: 'contingent',
      name:"Contingent Valuation",
      unit: "person",
      element: "Population",
      altUnits: null,
      qtyIndices: [
        { id: "quality", name: "Quality Index", included: true },
      ],
      valueIndices: []
    },
    {
      id: 'project',
      name:"Project Budget",
      unit: "projects",
      element: "Projects",
      altUnits: null,
      qtyIndices: [
        { id: "quality", name: "Quality Index", included: true },
      ],
      valueIndices: []
    }
  ]

}
